<template>
  <Teleport to="body">
    <div
      v-if="visible"
      class="lead-popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="lead-popup-title"
    >
      <div class="lead-popup__backdrop" @click="dismiss" />
      <div class="lead-popup__sheet" ref="sheetEl">
        <button type="button" class="lead-popup__close" aria-label="Fermer" @click="dismiss">
          ×
        </button>
        <h5 id="lead-popup-title" class="lead-popup__title">
          Epargner, investir, acheter... Faites vous les bons choix avec l'argent que vous gagnez ?
        </h5>
        <h5 id="lead-popup-title" class="lead-popup__title">
          Que se passerait-il financièrement pour vous et vos proches si vous arrêtiez de travailler demain ?
        </h5>
        <h5 id="lead-popup-title" class="lead-popup__title">
          Votre patrimoine est-il vraiment sous contrôle&nbsp;?
        </h5>
        <!-- <ul class="lead-popup__list">
          <li>Actifs dispersés, sans vision consolidée</li>
          <li>Charges qui grignotent l’épargne sans que vous le voyiez</li>
          <li>Décisions prises à l’aveugle faute de bilan clair</li>
        </ul> -->
        <p class="lead-popup__lead">
          En quelques minutes, clarifiez votre situation et découvrez comment structurer la suite.
        </p>
        <button type="button" class="btn-brand btn-brand--primary lead-popup__cta" @click="continueToDiagnostic">
          En savoir plus
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { nextTick, onBeforeUnmount, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { trackCtaClick } from '@/utils/analytics';

const STORAGE_KEY = 'patrimonea_home_lead_popup_seen';
const MOBILE_MQ = '(max-width: 768px)';

const router = useRouter();
const visible = ref(false);
const sheetEl = ref(null);
let mq = null;

function isMobile() {
  if (typeof window === 'undefined' || !window.matchMedia) return false;
  return window.matchMedia(MOBILE_MQ).matches;
}

function alreadySeen() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === '1';
  } catch (_) {
    return false;
  }
}

function markSeen() {
  try {
    sessionStorage.setItem(STORAGE_KEY, '1');
  } catch (_) {
    /* ignore */
  }
}

function openIfNeeded() {
  if (!isMobile() || alreadySeen()) {
    visible.value = false;
    return;
  }
  visible.value = true;
  nextTick(() => {
    sheetEl.value?.focus?.();
  });
}

function dismiss() {
  markSeen();
  visible.value = false;
  trackCtaClick({ location: 'home_lead_popup', label: 'Plus tard' });
}

function continueToDiagnostic() {
  markSeen();
  visible.value = false;
  trackCtaClick({ location: 'home_lead_popup', label: 'Continuer' });
  router.push({ path: '/diagnostic', query: { from: 'home_popup' } });
}

function onMqChange() {
  if (!isMobile()) visible.value = false;
  else openIfNeeded();
}

onMounted(() => {
  openIfNeeded();
  if (typeof window !== 'undefined' && window.matchMedia) {
    mq = window.matchMedia(MOBILE_MQ);
    if (mq.addEventListener) mq.addEventListener('change', onMqChange);
    else if (mq.addListener) mq.addListener(onMqChange);
  }
});

onBeforeUnmount(() => {
  if (!mq) return;
  if (mq.removeEventListener) mq.removeEventListener('change', onMqChange);
  else if (mq.removeListener) mq.removeListener(onMqChange);
});
</script>

<style scoped>
.lead-popup {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.lead-popup__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(1, 38, 62, 0.45);
}

.lead-popup__sheet {
  position: relative;
  width: 100%;
  max-width: 480px;
  margin: 0;
  padding: 1.5rem 1.35rem 1.75rem;
  border-radius: 20px 20px 0 0;
  background:
    radial-gradient(ellipse at 80% 0%, rgba(201, 162, 39, 0.14), transparent 55%),
    #fff;
  box-shadow: 0 -12px 40px rgba(1, 38, 62, 0.18);
  animation: lead-sheet-up 0.35s ease;
  max-height: 90vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@keyframes lead-sheet-up {
  from {
    transform: translateY(100%);
    opacity: 0.6;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.lead-popup__close {
  position: absolute;
  top: 0.65rem;
  right: 0.85rem;
  width: 2.25rem;
  height: 2.25rem;
  border: 0;
  background: transparent;
  font-size: 1.5rem;
  line-height: 1;
  color: var(--brand-navy, #01263e);
  cursor: pointer;
}

.lead-popup__title {
  margin: 0 0 1rem;
  font-family: var(--font-display, Georgia, serif);
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.3;
  color: var(--brand-navy, #01263e);
  padding-right: 1.5rem;
}

.lead-popup__list {
  margin: 0 0 1rem;
  padding-left: 1.15rem;
  color: #000000;
  font-size: 0.95rem;
  line-height: 1.55;
}

.lead-popup__list li + li {
  margin-top: 0.35rem;
}

.lead-popup__lead {
  margin: 0 0 1.25rem;
  font-size: 0.92rem;
  color: var(--brand-navy, #01263e);
  opacity: 0.85;
}

.lead-popup__cta {
  width: 100%;
  text-transform: none;
  letter-spacing: 0.02em;
  min-height: 48px;
}

.lead-popup__skip {
  display: block;
  width: 100%;
  margin-top: 0.65rem;
  border: 0;
  background: transparent;
  color: var(--brand-navy, #01263e);
  opacity: 0.65;
  font-size: 0.9rem;
  cursor: pointer;
  min-height: 44px;
}

@media (min-width: 769px) {
  .lead-popup {
    display: none;
  }
}
</style>
